import React, { useEffect, useState ,useRef } from 'react'
import { Generate } from './Generate'
import { Review } from './Review';
import { Summary } from './Summary';
import { Revenue } from './Revenue';


export const BillingTab = () => {
  const [selectedTab,setSelectedTab]=useState(1); 
  return (
    <>
    <div className="p-2 d-flex">
      <div className="button-container verticalTabButton" >
      <button
          className={`non-gappable-button ${selectedTab===1 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={()=>{setSelectedTab(1)}}
        >
          Generate
        </button>
   
        <button
          className={`non-gappable-button ${selectedTab===2 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={()=>{setSelectedTab(2)}}
        >
         Review
        </button>
        <button
          className={`non-gappable-button ${selectedTab===3 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={()=>{setSelectedTab(3)}}
          disabled
        >
         Summary
        </button>
        <button
          className={`non-gappable-button ${selectedTab===4 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={()=>{setSelectedTab(4)}}
          disabled
        >
         Revenue
        </button>
     
        
      </div>
      <div className='p-2 flex-grow-1'>
      {selectedTab===1 && <>  <Generate />  </> }
      {selectedTab===2 && <>  <Review />  </> }
      {selectedTab===3 && <>  <Summary />  </> }
      {selectedTab===4 && <>  <Revenue />  </> }
      </div>
      </div>
    </>
  )
}
export default BillingTab
